import { call, put } from 'redux-saga/effects';

import { ISubscriptionWellfunnel } from 'api/components/Subscriptions/types';
import api from 'api';

import { getUserFeatures } from 'store/user/actions';
import { restoreSubscription } from 'store/subscriptions/actions';
import { notifyError } from 'store/notifications/actions';
import { closeModal, openModal } from 'store/modals/actions';

import { trackScreenLoad } from 'services/Analytics/trackers/mainTrackers';

import { handleAuthError } from './utils';

import { getRestoreSuccessModalData } from 'helpers/subscriptions';
import { checkSubscriptionRestored } from '../helpers';

import { ModalName } from 'modals/types';

import { pollGetSubscriptions } from './pollGetSubscriptions';

export function* requestRestoreSubscription({ payload }: ReturnType<typeof restoreSubscription>) {
    try {
        yield call(api.subscriptions.restoreSubscription, {
            id: payload.external_id,
            provider: payload.payment_provider,
        });

        const [subscription]: ISubscriptionWellfunnel[] = yield call(
            pollGetSubscriptions,
            checkSubscriptionRestored(payload.external_id)
        );

        const { id, external_id, product, upcoming_product, subscription_period } = subscription;

        const { amount } = upcoming_product ?? product;

        yield put(
            openModal(
                ModalName.SuccessModal,
                getRestoreSuccessModalData(upcoming_product ?? { ...product, subscription_period })
            )
        );

        yield call(trackScreenLoad, 'restore_success', {
            subscription_id: external_id,
            period: subscription_period,
            main: `subscription | main | period: ${subscription_period} | price: ${amount}`,
            content_id: id,
        });

        yield put(getUserFeatures());
    } catch (error) {
        const authErrorWasHandled = yield* handleAuthError(error);

        if (authErrorWasHandled) return;

        yield put(closeModal());
        yield put(notifyError({ message: 'message.error.somethingWentWrong', autoClose: 10000 }));

        console.error(error);
    }
}
